import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'
import Iris from './Iris/Iris'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '17.72 14.71'
  const rightPupilTransformOrigin = '41.72 14.71'

  const leftEyePath =
    'M25.72,16.75s-1.11-5.58-5-5.93c-3.89-.35-15-.18-15-.18,0,0,.72,5.83,7.04,7.5,5.91,1.57,12.96-1.39,12.96-1.39Z'
  const rightEyePath =
    'M33.72,16.75s1.11-5.58,5-5.93c3.89-.35,15-.18,15-.18,0,0-.72,5.83-7.04,7.5-5.91,1.57-12.96-1.39-12.96-1.39Z'

  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path className="cls-4" d={leftEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={-rotation}
              maskPath={leftEyePath}
              gradientId={randomGradientId1}
              transformOrigin={leftPupilTransformOrigin}
            />
            <path
              className="cls-6"
              d="M17.72,17.21c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-5"
              d="M16.58,19.11c-1.31,0-2.65-.14-3.95-.48-6.58-1.74-7.4-7.86-7.41-7.92l-.07-.55h.56c.46-.01,11.18-.17,15.05,.17,4.21,.38,5.4,6.09,5.44,6.33l.08,.4-.38,.16c-.23,.1-4.57,1.89-9.33,1.89ZM6.33,11.14c.35,1.44,1.71,5.24,6.57,6.52,4.9,1.3,10.69-.64,12.24-1.21-.33-1.23-1.56-4.87-4.45-5.13-3.3-.29-12-.21-14.35-.18Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M26.29,17.05c-1.39-2.46-2.95-5.38-5.94-5.48l-3.02-.13c-4.07-.22-8.14-.48-12.16-1.29,5.09-.72,10.22-.69,15.32-.21,3.5,.22,5.44,4.13,5.8,7.11h0Z" />
            )}
          </g>
          <path
            className="cls-4"
            d="M19.39,13.86c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path className="cls-4" d={rightEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={rotation}
              maskPath={rightEyePath}
              gradientId={randomGradientId2}
              transformOrigin={rightPupilTransformOrigin}
            />
            <path
              className="cls-6"
              d="M41.72,17.21c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-5"
              d="M42.86,19.11c-4.76,0-9.1-1.8-9.33-1.89l-.38-.16,.08-.4c.05-.24,1.23-5.95,5.44-6.33,3.87-.35,14.6-.19,15.06-.18h.56l-.07,.56c0,.06-.83,6.19-7.41,7.92-1.29,.34-2.64,.48-3.94,.48Zm-8.55-2.66c1.55,.58,7.35,2.51,12.24,1.21,4.85-1.28,6.22-5.08,6.57-6.52-2.36-.03-11.05-.11-14.35,.18-2.9,.26-4.12,3.89-4.45,5.12Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M54.28,10.15c-5.27,.72-10.6,.87-15.84,1.52-2.5,.82-3.64,3.16-5.28,5.38,.05-2.7,1.42-5.67,4.06-6.77,1.55-.54,3.23-.33,4.82-.44,4.09-.06,8.16,0,12.24,.31h0Z" />
            )}
          </g>
          <path
            className="cls-4"
            d="M43.39,13.86c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>

      <defs>
        <clipPath id="clippath">
          <rect className="cls-1" x="5.72" y="10.6" width="20" height="8" />
        </clipPath>
        <linearGradient
          id={randomGradientId1}
          x1="17.72"
          y1="112.73"
          x2="17.72"
          y2="120.27"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <clipPath id="clippath-1">
          <rect className="cls-1" x="33.72" y="10.6" width="20" height="8" />
        </clipPath>
        <linearGradient
          id={randomGradientId2}
          x1="41.72"
          y1="112.65"
          x2="41.72"
          y2="120.59"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
